import React, { useState, useEffect } from "react";
import Layout from "../../components/layout/Layout";
import NoImage from "../../assets/images/noimages.jpg";
import { APIURL } from "../../redux/action/config";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import { updateProfile } from "../../redux/action/auth";
import { ToastContainer, toast } from "react-toastify";
import loader from '../../components/loader/loader'
import EditCustomerPassword from "../../components/modals/EditCustomerPassword";
const initialState = { alt: "", src: "" };

const Profile = () => {
  const [activeLoader, setActiveLoader] = useState(false);

  const [{ alt, src }, setPreview] = useState(initialState);
  const [img, setImg] = useState();
  const token = localStorage.getItem("token");

  const fileHandler = (event) => {
    const { files } = event.target;
    var formdata = new FormData();

    formdata.append("image", event.target.files[0]);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/image`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == "success") {
          setActiveLoader(false);
          setImg(result.data.images.image);
        }
      })
      .catch((error) => console.log("error", error));
    setPreview(
      files.length
        ? {
          src: URL.createObjectURL(files[0]),
          alt: files[0].name,
        }
        : initialState
    );
    setActiveLoader(true);
  };
  const [loading, setLoading] = useState(false);
  const [profileDetails, setProfileDetails] = useState();

  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
  
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };
  
        // Get user
        const userResponse = await axios.get(`${APIURL}/api/v1/users/${id}`, config);
        setPreview({ src: APIURL + "/" + userResponse?.data?.data?.user?.image });
  
        // Get phone numbers
        const phoneNumberResponse = await axios.get(`${APIURL}/api/v1/enquiry/phoneNumber/admin/get`, config);
        setProfileDetails({
          ...userResponse.data,
          phoneNumbers: phoneNumberResponse?.data?.data,
        });
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  
  }, [id]);
  

  const handleUpdateNumbers = async (data) => {
    setLoading(true)
    var body = JSON.stringify({
      phone1: data?.phone1,
      phone2: data?.phone2
    });
    const token = localStorage.getItem("token");

    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      await axios.post(
        `${APIURL}/api/v1/enquiry/update`,
        body,
        config
      );
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false)
    }
  }

  const profile = profileDetails?.data?.user ? profileDetails?.data?.user : "";

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Profile">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            {!loading ? (<div className="card">
              <div className="card-header align-items-center">
                <div className="card-title fs-3 fw-bolder">
                  Profile Settings
                </div>
                <EditCustomerPassword editDetails={profile} modalId={'custPassModal'} />
                <button
                  type="submit"
                  className="btn btn-primary py-1 px-3 mx-5"
                  data-bs-toggle="modal"
                  data-bs-target="#custPassModal"
                >
                  <span className="indicator-label">
                    Change password
                  </span>
                </button>
              </div>
              <Formik
                initialValues={{
                  id: profile?.id,
                  position: "user_admin",
                  email: profile?.email,
                  phone: profile?.phone,
                  firstName: profile?.firstName,
                  phone2: profileDetails?.phoneNumbers?.phone2,
                  phone1: profileDetails?.phoneNumbers?.phone1
                }}
                onSubmit={(values) => {
                  if (img !== "undefined") {
                    values.image = img;
                  } else {
                    values.image = profile?.image;
                  }
                  dispatch(updateProfile(values, id));
                  handleUpdateNumbers(values)
                }}
              >
                {({ values, handleBlur, handleChange, handleSubmit }) => (
                  <form
                    className="form fv-plugins-bootstrap5 fv-plugins-framework"
                    onSubmit={handleSubmit}
                  >
                    <div className="card-body p-9">
                      <div className="row mb-5">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">
                            Profile picture
                          </div>
                        </div>
                        <div className="col-lg-8">
                          <div
                            className="image-input w-125px h-125px image-input-outline"
                            style={{
                              backgroundImage: `url(${src || NoImage})`,
                            }}
                          >
                            <label
                              className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                              data-kt-image-input-action="change"
                              data-bs-toggle="tooltip"
                              title=""
                              data-bs-original-title="Change avatar"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-pencil"
                                viewBox="0 0 16 16"
                              >
                                <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"></path>
                              </svg>
                              <input
                                id="file-input"
                                accept="image/*"
                                type="file"
                                onChange={fileHandler}
                              />
                              <input type="hidden" name="avatar_remove" />
                            </label>
                            <span
                              className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                              data-kt-image-input-action="cancel"
                              data-bs-toggle="tooltip"
                              title=""
                              data-bs-original-title="Cancel avatar"
                            >
                              <i className="bi bi-x fs-2"></i>
                            </span>
                            {activeLoader == true ? (
                              <div
                                className="d-flex align-items-center justify-content-center h-100"
                                style={{ background: "#e2e2e270" }}
                              >
                                <div className="spinner-border w-80" role="status">
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="form-text">
                            Allowed file types: png, jpg, jpeg.
                          </div>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">Name</div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="firstName"
                            id="firstName"
                            defaultValue={
                              profile?.firstName
                                ? profile?.firstName
                                : values.firstName
                            }
                          />
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">Phone</div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="phone"
                            id="phone"
                            defaultValue={
                              profile?.phone ? profile?.phone : values.phone
                            }
                          />
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">Alternate phone 1</div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="phone1"
                            id="phone1"
                            defaultValue={
                              profileDetails?.phoneNumbers?.phone1 ? profileDetails?.phoneNumbers?.phone1 : values.phone1
                            }
                          />
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">Alternate phone 2</div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="phone2"
                            id="phone2"
                            defaultValue={
                              profileDetails?.phoneNumbers?.phone2 ? profileDetails?.phoneNumbers?.phone2 : values.phone2
                            }
                          />
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">Position</div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="position"
                            id="position"
                            value={
                              profile?.position == "user_admin" ? "Admin" : ""
                            }
                            disabled
                          />
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">
                            Email
                          </div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <input
                            className="form-control form-control-solid"
                            rows="3"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="email"
                            id="email"
                            defaultValue={
                              profile?.email ? profile?.email : values.email
                            }
                          />
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer d-flex justify-content-end py-6 px-9">
                      <Link
                        to="/dashboard"
                        type="reset"
                        className="btn btn-light btn-active-light-primary me-2"
                      >
                        Discard
                      </Link>
                      <button type="submit" className="btn btn-primary">
                        Save Changes
                      </button>
                    </div>
                    <input type="hidden" />
                    <div></div>
                  </form>
                )}
              </Formik>
            </div>) : loader()}
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};
export default connect(null, { updateProfile })(Profile);
